import InputPriceWrapper from './InputPriceWrapper';

export default InputPriceWrapper;
